/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import type { EuiSuperSelectOption } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

export const SCORE_OPTIONS = Array.from({ length: 11 }, (_, i) => ({
  id: i.toString(),
  label: i,
}))

export enum DeletionReasonsValues {
  TOO_EXPENSIVE = 'too_expensive',
  PRICING_CONFUSION = 'pricing_confusion',
  MISSING_FUNCTIONALITY = 'missing_functionality',
  SCALABILITY_STABILITY = 'scalability_stability',
  LACK_OF_DOCUMENTATION = 'lack_of_documentation',
  SOMETHING_ELSE = 'something_else',
}

export const DELETION_REASONS: Array<EuiSuperSelectOption<DeletionReasonsValues>> = [
  {
    value: DeletionReasonsValues.TOO_EXPENSIVE,
    inputDisplay: (
      <FormattedMessage
        id='deletion-survey-form.reason-for-deletion.too-expensive'
        defaultMessage='Too expensive'
      />
    ),
  },
  {
    value: DeletionReasonsValues.PRICING_CONFUSION,
    inputDisplay: (
      <FormattedMessage
        id='deletion-survey-form.reason-for-deletion.pricing-confusion'
        defaultMessage='Pricing confusion'
      />
    ),
  },
  {
    value: DeletionReasonsValues.MISSING_FUNCTIONALITY,
    inputDisplay: (
      <FormattedMessage
        id='deletion-survey-form.reason-for-deletion.missing-functionality'
        defaultMessage='Missing functionality'
      />
    ),
  },
  {
    value: DeletionReasonsValues.SCALABILITY_STABILITY,
    inputDisplay: (
      <FormattedMessage
        id='deletion-survey-form.reason-for-deletion.scalability-stability'
        defaultMessage='Scalability and stability issues'
      />
    ),
  },
  {
    value: DeletionReasonsValues.LACK_OF_DOCUMENTATION,
    inputDisplay: (
      <FormattedMessage
        id='deletion-survey-form.reason-for-deletion.lack-of-documentation'
        defaultMessage='Lack of documentation'
      />
    ),
  },
  {
    value: DeletionReasonsValues.SOMETHING_ELSE,
    inputDisplay: (
      <FormattedMessage
        id='deletion-survey-form.reason-for-deletion.something-else'
        defaultMessage='Something else'
      />
    ),
  },
]
